<template>
  <div>
    <a-card :loading="searchCardLoading" class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        formLayout="inline"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button
          v-if="isAdmin"
          type="primary"
          icon="plus"
          class="add-btn"
          @click="visible = true"
        >
          新增文件夹
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:status="{ tableRow }">
          <a-tag :color="tableRow.status | statusTypeFilter">
            {{ tableRow.status | statusFilter }}
          </a-tag>
        </template>
        <template v-slot:files="{ tableRow }">
          <a-popover title="点击下载" trigger="hover">
            <template slot="content">
              <div v-if="tableRow.files.length">
                <p v-for="item in tableRow.files" :key="item.id">
                  <a herf="javascript:;" @click="handleDownload(item.id)">
                    {{ tableRow.files.length && item.name }}
                  </a>
                </p>
              </div>
              <a-empty v-else />
            </template>
            <a href="javascript:;" size="small" type="link">
              移入查看
            </a>
          </a-popover>
        </template>
        <template v-slot:action="{ tableRow }" v-if="isAdmin">
          <div>
            <a-button
              type="link"
              size="small"
              :disabled="actionBtnDisabled(tableRow)"
              @click="handleEdit(tableRow)"
            >
              编辑
            </a-button>
            <a-divider type="vertical" />
            <a-popconfirm
              title="是否删除该文件夹?"
              @confirm="handleDeleteConfirm(tableRow)"
            >
              <a-icon slot="icon" type="question-circle-o" class="icon-color" />
              <a-button
                type="link"
                size="small"
                :disabled="actionBtnDisabled(tableRow)"
              >
                删除
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </TableView>
    </a-card>

    <a-modal
      v-model="visible"
      :title="modelTitle"
      destroyOnClose
      @ok="handleSubmit"
      :maskClosable="false"
      :afterClose="handleAfterClose"
    >
      <a-form :form="folderForm">
        <a-form-item label="文档类型">
          <a-select v-decorator="$decorator('type', '请选择文档类型')">
            <a-select-option v-for="item in selectList" :key="item.value">
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="文档名称(100个字符以内)">
          <a-input
            :maxLength="100"
            allowClear
            v-decorator="$decorator('name', '文档名称不能为空')"
          ></a-input>
        </a-form-item>
        <a-form-item label="备注(200个字符以内)">
          <a-textarea
            :maxLength="200"
            :auto-size="{ minRows: 3, maxRows: 5 }"
            allowClear
            v-decorator="$decorator('remark', '', [{ required: false }])"
          ></a-textarea>
        </a-form-item>
        <a-form-item label="选择文件">
          <a-upload
            multiple
            :beforeUpload="handleBeforeUpload"
            :remove="handleRemove"
            :default-file-list="defaultFileList"
            :fileList="fileList"
            @change="handleFileList"
          >
            <a-button>
              <a-icon type="upload" />
              选取文件
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import {
  getSelectList,
  getTableData,
  download,
  deleteDocument,
  updateDocument,
  removeUploadDocument,
  checkIsAdmin,
} from './api'
import mixin from './mixin'
import { ERR_OK } from '@/config'

const statusMap = {
  1: {
    color: 'green',
    text: '生效',
  },
  2: {
    color: 'red',
    text: '失效',
  },
}

export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
  },
  data() {
    return {
      isAdmin: false,
      searchCardLoading: true,
      tableLoading: true,
      visible: false,
      fileList: [],
      defaultFileList: [],
      folderForm: this.$form.createForm(this),
      modelTitle: '新增',
    }
  },
  mounted() {
    this._checkIsAdmin()
    this._getSelectList()
    this._getTableData()
  },
  filters: {
    statusTypeFilter(type) {
      return statusMap[type].color
    },
    statusFilter(type) {
      return statusMap[type].text
    },
  },
  methods: {
    // 检查是否为系统管理员角色
    async _checkIsAdmin() {
      const { code, data } = await checkIsAdmin()
      if (code === ERR_OK) {
        this.isAdmin = data.roleAdmin
      }
    },
    // 获取文件类型数据
    _getSelectList() {
      getSelectList().then(({ data }) => {
        this.selectList = data.map(item => ({
          text: item.name,
          value: item.name,
        }))

        this.searchSchema[2]['selectList'].push(...this.selectList)
        this.searchCardLoading = false
      })
    },
    // 获取表格数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
      }
      if (formData.date.length) {
        formData.startTime = formData.date[0]
        formData.endTime = formData.date[1]
      }
      delete formData.date
      delete formData.pageSize

      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },
    // 操作按钮是否禁用
    actionBtnDisabled({ status }) {
      return status !== 1
    },
    // 编辑
    handleEdit({ id, type, name, remark, files }) {
      this.visible = true
      this.modelTitle = '编辑'

      setTimeout(() => {
        this.folderForm.setFieldsValue({
          type,
          name,
          remark,
        })
        this.id = id

        if (files.length) {
          this.defaultFileList.push(
            ...files.map(item => {
              return {
                uid: item.id,
                name: item.name,
                status: 'done',
              }
            }),
          )
          this.fileList = [...this.defaultFileList]
        }
      }, 20)
    },
    // 点击文件链接下载
    handleDownload(id) {
      download(id)
    },
    // 删除表格数据
    async handleDeleteConfirm({ id }) {
      try {
        const { message } = await deleteDocument(id)

        this.$notification.success({
          message: '提示',
          description: message,
        })

        this._getTableData()
      } catch (e) {
        // No processing
      }
    },
    // 提交和编辑
    handleSubmit() {
      this.folderForm.validateFields(async (err, values) => {
        if (!err) {
          const { fileList } = this
          if (!this.id) {
            this.id = ''
          }
          try {
            const { message } = await updateDocument({
              ...values,
              id: this.id,
              file: fileList,
            })
            this.visible = false

            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 弹窗关闭
    handleAfterClose() {
      this.fileList = []
      this.id = ''
      this.defaultFileList = []
      this.modelTitle = '新增'
    },
    // 上传之前
    handleBeforeUpload(file) {
      this.fileList = [...this.fileList, file]
      return false
    },
    // 限制一次最多上传三个文件
    handleFileList() {
      if (this.fileList.length > 3) {
        this.$notification.warning({
          message: '提示',
          description: '最多可以上传三个文件',
        })
        this.remove(this.fileList.length - 1)
      }
    },
    // 删除上传文件
    handleRemove(file) {
      const index = this.fileList.findIndex(item => item.uid === file.uid)
      return new Promise(resolve => {
        if (!file.lastModified) {
          const { uid, name } = this.fileList[index]

          this.$confirm({
            title: '提示',
            content: h =>
              h('p', {}, [
                '确定删除 ',
                h('span', { style: 'fontWeight: bold; color: #1890ff ' }, name),
                ' 文件？',
              ]),
            onOk: () => {
              removeUploadDocument(uid).then(() => {
                this.remove(index)
                resolve(true)
              })
            },
          })
        } else {
          this.remove(index)
          resolve(true)
        }
      })
    },
    // 本地删除
    remove(index) {
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
  },
}
</script>
